export default "__VITE_ASSET__akKAx63Y__"